// extracted by mini-css-extract-plugin
export default {"container":"CookieConsent_container__x7dVv","buttonWrapper":"CookieConsent_buttonWrapper__QDgGg","button":"CookieConsent_button__mDTuB"};